/** Gate verdicts that record a run waiting for a person rather than refusing. */
export const waitForAPersonCodes = [
  'plan.declared_file_not_proposable',
  'design.declared_file_not_proposable',
  'any.awaiting_checkpoint',
  'analysis.premise_unsettleable',
  'analysis.requested_data_reference_unaddressable',
  'analysis.brief_unconfirmed',
  'analysis.scope_unresolved',
  'any.brief_amendment_requested',
  'any.spend_cap_reached',
  'any.not_reviewed',
] as const

export type VerdictClass = 'pass' | 'wait' | 'refusal'

export function verdictClass(verdict: { passed: boolean; code?: string }): VerdictClass {
  if (verdict.passed) return 'pass'
  return waitForAPersonCodes.includes(verdict.code as typeof waitForAPersonCodes[number])
    ? 'wait'
    : 'refusal'
}
